module.exports = __webpack_public_path__ + "assets/images/intro-bg-6_fa5f80ba25a6769bee13cc2e9711b287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro/intro-bg-6.png
// module id = 131
// module chunks = 0